import { render, staticRenderFns } from "./GlobalA.vue?vue&type=template&id=13a5d664&scoped=true"
import script from "./GlobalA.vue?vue&type=script&lang=js"
export * from "./GlobalA.vue?vue&type=script&lang=js"
import style0 from "./GlobalA.vue?vue&type=style&index=0&id=13a5d664&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a5d664",
  null
  
)

export default component.exports